<app-template-map [control]="control" [markerDisplayComponent]="markerDisplayComponent" />
